import styled from '@emotion/styled'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'

const TabContent = ({ title, textContent, img, textPosition }) => {
  return (
    <Style>
      <Row>
        {textPosition !== 'left' && (
          <Col sm={24} md={24} lg={12} xl={12}>
            <div className='img-content'>
              <img alt='' src={img} className='img-content' />
            </div>
          </Col>
        )}
        <Col sm={24} md={24} lg={12} xl={12}>
          <div className='text-content'>
            <div className='text-content-title'>{title}</div>
            <div className='text-content-detail'>{textContent}</div>
          </div>
        </Col>
        {textPosition === 'left' && (
          <Col sm={24} md={24} lg={12} xl={12}>
            <div className='img-content'>
              <img alt='' src={img} className='img-content' />
            </div>
          </Col>
        )}
      </Row>
    </Style>
  )
}

const Style = styled.div`
  label: tab-content;
  padding: 40px;
  .text-content {
    .text-content-title {
      font-size: 20px;
      font-weight: bold;
    }
    .text-content-detail {
      padding: 30px 0;
      font-size: 16px;
    }
  }
  .img-content {
    text-align: center;
    img {
      @media only screen and (max-width: 700px) {
        width: 240px;
      }
      width: 300px;
    }
  }
`
export default TabContent
